// extracted by mini-css-extract-plugin
module.exports = {"rectangleParent":"DimensionComponents_rectangleParent__O828A","dimImage":"DimensionComponents_dimImage__MF8ze","iconDiv":"DimensionComponents_iconDiv__AYe0_"};